import { render, staticRenderFns } from "./PasswordExpireWarningModal.vue?vue&type=template&id=71db81cc&scoped=true"
import script from "./PasswordExpireWarningModal.vue?vue&type=script&lang=js"
export * from "./PasswordExpireWarningModal.vue?vue&type=script&lang=js"
import style0 from "./PasswordExpireWarningModal.vue?vue&type=style&index=0&id=71db81cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71db81cc",
  null
  
)

export default component.exports